import axios from 'axios'

export const signInPathWithPreviousLocationInQuery = () => {
  if (window.location.pathname.includes('sign-in'))
    return window.location.pathname + window.location.search

  return `/sign-in?redirect=${encodeURIComponent(
    window.location.pathname + window.location.search
  )}`
}

export const logout = (href = '/sign-in') => {
  localStorage.removeItem('token')
  localStorage.removeItem('currentWorkspace')

  window.location.href = href
}

export const getLogoutUrl = () => {
  return `${process.env.REACT_APP_API_GATEWAY_URL}/logout`
}

export const stopImpersonate = async () => {
  const originUrl = window.location.origin
  const logoutUrl = getLogoutUrl()
  const token = localStorage.getItem('token')

  await axios({
    headers: {
      authorization: token ? `Bearer ${token}` : '',
      'content-type': 'application/json'
    },
    method: 'get',
    baseURL: logoutUrl
  }).then(response => {
    const { token } = response.data
    localStorage.setItem('token', token)
    window.location.href = `${originUrl}/back-office`
  })
}

export const logoutViaServer = async () => {
  const logoutUrl = getLogoutUrl()

  const token = localStorage.getItem('token')

  await axios({
    headers: {
      authorization: token ? `Bearer ${token}` : '',
      'content-type': 'application/json'
    },
    method: 'get',
    baseURL: logoutUrl
  }).then(response => {
    logout()
  })
}

export const ssoUrlWithTokenUrl = (url: string) => {
  try {
    const ssoURL = new URL(url)

    console.log('\x1b[32m', '\n--------------Debug----------------\n')
    console.log('\x1b[36m', `ssoURL = `, ssoURL)
    console.log('\x1b[32m', '\n-----------------------------------', '\x1b[0m')
    if (ssoURL.origin.includes('screenhub.com') || ssoURL.origin.includes('localhost')) {
      const token = localStorage.getItem('token')
      if (token) {
        ssoURL.hash = `#token=${token}`
      }
    }
    return ssoURL.toString()
  } catch (error) {
    console.log(`unable to generate SSO token for URL ${url}`, error)
    return url
  }
}
